import LinkToDocusaurus from '../LinkToDocusaurus'
import { Color, Paragraph } from '@eggplant/pattern-library'
import { runner } from '../../docs-routes'

const RunSelectedStepsStatusFilterDescription = () =>
  <Paragraph>
    <Color variant='theme-description-text'>
      Step statuses are from the latest test config run and are specific to each config. Other test configs with the same step may have different statuses. Changes to test steps in test config settings will reset all statuses to untested.
    </Color>
    <br />
    <br />
    <Paragraph>
      <LinkToDocusaurus path={runner}>Learn more in the DAI documentation</LinkToDocusaurus>
    </Paragraph>
  </Paragraph>

export default RunSelectedStepsStatusFilterDescription
